export const onboardingConfig = [
  {
    id: 1,
    labelKey: 'onboarding.step1.label',
    descriptionKey: 'onboarding.step1.description',
    image: 'assets/images/gbp-logo.jpg',
    icon: 'fab fa-google',
    callToActionKey: 'onboarding.step1.call_to_action',
    actionLinkKey: 'onboarding.step1.action_link',
    complete: false
  },
  {
    id: 2,
    labelKey: 'onboarding.step2.label',
    descriptionKey: 'onboarding.step2.description',
    image: 'assets/images/website-access.png',
    icon: 'fas fa-key',
    callToActionKey: 'onboarding.step2.call_to_action',
    complete: false
  },
  {
    id: 3,
    labelKey: 'onboarding.step3.label',
    descriptionKey: 'onboarding.step3.description',
    image: 'assets/images/content-survey.png',
    icon: 'fas fa-file-alt',
    callToActionKey: 'onboarding.step3.call_to_action',
    complete: false
  }
];
